import AbstractEntity from "../AbstractEntity";

export default class Work extends AbstractEntity {
    _id;
    _name;
    _legalDocumentTemplatesId;
    _skillsId;

    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getLegalDocumentTemplatesId() {
        return this._legalDocumentTemplatesId;
    }

    getSkillsId() {
        return this._skillsId;
    }

    getClassName() {
        return "work";
    }
}